export interface IGamecastStreamGroup {
  streamGroupId: string;
  region: string;
  eventId: string;
  additionalLaunchArgs: string[];
  status: IStreamGroupStatus;
}

export enum StreamSessionStatus {
  ACTIVATING = 'ACTIVATING',
  ACTIVE = 'ACTIVE',
  CONNECTED = 'CONNECTED',
  ERROR = 'ERROR',
  PENDING_CLIENT_RECONNECTION = 'PENDING_CLIENT_RECONNECTION',
  RECONNECTING = 'RECONNECTING',
  TERMINATED = 'TERMINATED',
  TERMINATING = 'TERMINATING',
  NO_MACHINES = 'NO_MACHINES',
}

export declare const StreamSessionStatusReason: {
  readonly APP_LOG_S3_DESTINATION_ERROR: 'applicationLogS3DestinationError';
  readonly INTERNAL_ERROR: 'internalError';
  readonly INVALID_SIGNAL_REQUEST: 'invalidSignalRequest';
  readonly PLACEMENT_TIMEOUT: 'placementTimeout';
};

export interface IStartStreamSessionOutput {
  Arn?: string;
  Description?: string;
  StreamGroupId?: string;
  UserId?: string;
  Status?: StreamSessionStatus;
  StatusReason?: typeof StreamSessionStatusReason;
  Protocol?: string;
  Location?: string;
  SignalRequest?: string;
  SignalResponse?: string;
  ConnectionTimeoutSeconds?: number;
  SessionLengthSeconds?: number;
  AdditionalLaunchArgs?: string[];
  AdditionalEnvironmentVariables?: Record<string, string>;
  SaveFileLocationUri?: string;
  LogFileLocationUri?: string;
  WebSdkProtocolUrl?: string;
  LastUpdatedAt?: Date;
  CreatedAt?: Date;
  ApplicationArn?: string;
}

export interface IGamecastConfig {
  eventId: string;
  Arn: string;
  Description: string;
  DefaultApplication: {
    Id: string;
  };
  DesiredCapacity: number;
  StreamClass: string;
  ActiveCapacity: number;
  IdleCapacity: number;
  Id: string;
  Status: string;
  LastUpdatedAt: string;
  CreatedAt: string;
  region: string;
  eventName?: string;
  LocationStates: {
    AllocatedCapacity: number;
    IdleCapacity: number;
    RequestedCapacity: number;
    AlwaysOnCapacity: number;
    LocationName: string;
    OnDemandCapacity: number;
    Status: string;
  }[];
}

export enum IStreamGroupStatus {
  Activating = 'ACTIVATING',
  Updating = 'UPDATING',
}

export interface IGetStreamGroupParams {
  eventId: string;
  streamGroupId: string;
  region: string;
}

export interface ILoadStreamGroupProps {
  eventId: string;
}
